import { useEffect, useState } from "react";

function getRemaining(target) {
  if (!target || Number.isNaN(target)) return { days: 0, hours: 0, mins: 0, secs: 0, ready: false };
  const total = Math.max(0, target - Date.now());
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const mins = Math.floor((total / 1000 / 60) % 60);
  const secs = Math.floor((total / 1000) % 60);
  return { days, hours, mins, secs, ready: true };
}

export default function Countdown({ targetIso, light = false }) {
  // Parse target defensively — invalid / missing ISO becomes NaN so
  // getRemaining() returns { ready: false } instead of using a hard-coded
  // past date that would freeze the timer at 00.
  const target = targetIso ? new Date(targetIso).getTime() : NaN;
  const [t, setT] = useState(() => getRemaining(target));

  // Re-initialize state AND restart the interval whenever the target changes.
  // Fixes the previous bug where the initial state (based on a null / stale
  // target) persisted after the /api/config async response arrived.
  useEffect(() => {
    setT(getRemaining(target));
    const id = setInterval(() => setT(getRemaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const cells = [
    { label: "Days", val: t.days },
    { label: "Hours", val: t.hours },
    { label: "Min", val: t.mins },
    { label: "Sec", val: t.secs },
  ];

  return (
    <div data-testid="countdown" className="grid grid-cols-4 gap-2" data-ready={t.ready ? "true" : "false"}>
      {cells.map((c) => (
        <div
          key={c.label}
          className={
            light
              ? "bg-white border border-[var(--line)] rounded-xl p-4 text-center"
              : "bg-bone border border-[var(--line)] rounded-xl p-4 text-center"
          }
          data-testid={`countdown-${c.label.toLowerCase()}`}
        >
          <div className="font-display text-2xl sm:text-3xl text-ink tabular-nums tracking-[-0.02em]">
            {String(c.val).padStart(2, "0")}
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--muted)] mt-1.5">
            {c.label}
          </div>
        </div>
      ))}
    </div>
  );
}
